export default "__VITE_ASSET__FxUlT0ay__"